import { useEffect, useRef, useState } from "react";

const NEXT = { in: "hold", hold: "out", out: "in" };
const LABEL = { in: "Breathe in", hold: "Hold", out: "Breathe out" };

export function BreathingOrb({ size = 260, inhale = 4000, hold = 2000, exhale = 6000, running = true, onPhase, light = false }) {
  const [phase, setPhase] = useState(null);
  const timer = useRef(null);
  const cb = useRef(onPhase);
  cb.current = onPhase;

  useEffect(() => {
    clearTimeout(timer.current);
    if (!running) {
      setPhase(null);
      return;
    }
    const dur = { in: inhale, hold, out: exhale };
    const cycle = (p) => {
      setPhase(p);
      cb.current?.(p);
      timer.current = setTimeout(() => cycle(NEXT[p]), dur[p]);
    };
    cycle("in");
    return () => clearTimeout(timer.current);
  }, [running, inhale, hold, exhale]);

  const scale = phase === "in" || phase === "hold" ? 1 : phase === "out" ? 0.55 : 0.62;
  const ms = phase === "in" ? inhale : phase === "out" ? exhale : 800;
  const d = size * 0.8;
  const common = { width: d, height: d, transitionProperty: "transform", transitionDuration: `${ms}ms`, transitionTimingFunction: "cubic-bezier(.45,0,.55,1)" };

  return (
    <div className="relative grid place-items-center" style={{ width: size, height: size }} data-testid="breathing-orb">
      <div className="absolute rounded-full bg-t-brand opacity-35 blur-[2px]" style={{ ...common, transform: `scale(${scale * 1.18})` }} />
      <div className="absolute rounded-full bg-t-brand grid place-items-center shadow-[0_20px_60px_-20px_var(--brand)]" style={{ ...common, transform: `scale(${scale})` }}>
        <span className={`font-semibold text-xl ${light ? "text-white" : "text-t-onbrand"}`} data-testid="breathing-phase">{phase ? LABEL[phase] : ""}</span>
      </div>
    </div>
  );
}
